var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcChart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 21V4.5H14.25V21H11.25V10.5H5.25V21H3V1.5H1.5V21C1.5 21.4 1.66 21.78 1.94 22.06C2.22 22.34 2.6 22.5 3 22.5H22.5V21H20.25ZM9.75 21H6.75V12H9.75V21ZM18.75 21H15.75V6H18.75V21Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChart);
export default __webpack_public_path__ + "static/media/ic-chart.e8b243264e594d93c23b312fea2ea023.svg";
export { ForwardRef as ReactComponent };